// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-component {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.sidebar-component .top {
    width: 100%;
    padding: 24px;
    padding-bottom: 0;
    height: 96px;
}

.sidebar-component .top a {
    width: 100%;
    height: 100%;
    border-bottom: 1px solid #D9D9D9;
    display: flex;
    align-items: center;
    text-decoration: none;
}

.sidebar-component .top img {
    width: 56px;
}

.sidebar-component .links-wrap {
    margin-top: 54px;
}

.sidebar-component .links-wrap * {
    font-family: Montserrat;
}

.sidebar-component .links-wrap a {
    text-decoration: none;
}

.sidebar-component .links-wrap p {
    color: #121212;
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    padding: 10px 24px; 
}

.sidebar-component .links-wrap p:hover {
    background-color: #F2F2F2;
}

.sidebar-component .links-wrap p.active-link {
    background-color: #F2F2F2;
}

.sidebar-component .accordion-body {
    padding: 0;
}

.sidebar-component .accordion-button * {
    color: #036323 !important;
}

.sidebar-component .accordion-button {
    color: #036323 !important;
    background-color: #fff;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    box-shadow: none;
    background-color: #03632320 !important;
    box-shadow: none !important;
}

.sidebar-component .collapsed {
    background-color: #ffffff !important;
    color: #000000 !important;
}

.sidebar-component .logout {
    display: flex;
    align-items: center;
    padding: 16px;
    cursor: pointer;
    margin-top: auto;
    transition: 0.3s;
}

.sidebar-component .logout img {
    width: 24px;
    height: 24px;
    margin-right: 5px;
}

.sidebar-component .logout p {
    margin: 0;
    color: #D61919;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.sidebar-component .logout:hover {
    background-color: #D6191920;
}

.karantin-logo {
    font-size: 24px;
    color: #036323;
    margin: 0;
    text-transform: uppercase;
    font-family: Montserrat;
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;AACpB","sourcesContent":[".sidebar-component {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.sidebar-component .top {\n    width: 100%;\n    padding: 24px;\n    padding-bottom: 0;\n    height: 96px;\n}\n\n.sidebar-component .top a {\n    width: 100%;\n    height: 100%;\n    border-bottom: 1px solid #D9D9D9;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n}\n\n.sidebar-component .top img {\n    width: 56px;\n}\n\n.sidebar-component .links-wrap {\n    margin-top: 54px;\n}\n\n.sidebar-component .links-wrap * {\n    font-family: Montserrat;\n}\n\n.sidebar-component .links-wrap a {\n    text-decoration: none;\n}\n\n.sidebar-component .links-wrap p {\n    color: #121212;\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0;\n    padding: 10px 24px; \n}\n\n.sidebar-component .links-wrap p:hover {\n    background-color: #F2F2F2;\n}\n\n.sidebar-component .links-wrap p.active-link {\n    background-color: #F2F2F2;\n}\n\n.sidebar-component .accordion-body {\n    padding: 0;\n}\n\n.sidebar-component .accordion-button * {\n    color: #036323 !important;\n}\n\n.sidebar-component .accordion-button {\n    color: #036323 !important;\n    background-color: #fff;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    box-shadow: none;\n    background-color: #03632320 !important;\n    box-shadow: none !important;\n}\n\n.sidebar-component .collapsed {\n    background-color: #ffffff !important;\n    color: #000000 !important;\n}\n\n.sidebar-component .logout {\n    display: flex;\n    align-items: center;\n    padding: 16px;\n    cursor: pointer;\n    margin-top: auto;\n    transition: 0.3s;\n}\n\n.sidebar-component .logout img {\n    width: 24px;\n    height: 24px;\n    margin-right: 5px;\n}\n\n.sidebar-component .logout p {\n    margin: 0;\n    color: #D61919;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n.sidebar-component .logout:hover {\n    background-color: #D6191920;\n}\n\n.karantin-logo {\n    font-size: 24px;\n    color: #036323;\n    margin: 0;\n    text-transform: uppercase;\n    font-family: Montserrat;\n    margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
